/* adds a mark for text occurrence in a value */
function addTextMark(value, text) {
	return value.replace(
		new RegExp("(" + text + ")", "ig"),
		"<span class='webix_um_search_mark'>$1</span>"
	);
}

export function text(view) {
	return function(data, type, value) {
		let search = view.EscapedSearchText;
		if (search) {
			value = addTextMark(value, search);
		}
		return value;
	};
}

export function rule(view) {
	return function(data) {
		let search = view.EscapedSearchText;
		let short = data.short;
		let long = data.long;
		if (search) {
			short = addTextMark(short, search);
			long = addTextMark(long, search);
		}
		return short + `<div class='webix_um_details_row'>${long}</div>`;
	};
}

export function statusBadge(value, _) {
	let status = value ? "Active" : "Not active";
	let cssStatusName = value ? "active" : "not_active";

	let html = `
		<div class="webix_um_badge_container">
			<span class="webix_um_status_badge webix_um_${cssStatusName}">${_(
		status
	)}</span>
		</div>`;
	return html;
}

export function roleAvatar(role, cssClass) {
	let css = typeof cssClass == "string" ? cssClass : "webix_um_role_avatar";
	return `<div class='${css}' style='background-color: ${
		role.color ? role.color : ""
	}'>${role.name ? role.name.charAt(0).toUpperCase() : ""}</div>`;
}

function userCss(name) {
	return " webix_um_avatar_" + ((name.charCodeAt(1) + (name.length % 10)) % 10);
}

export function userAvatar(user, cssClass) {
	let css = typeof cssClass == "string" ? cssClass : "webix_um_member_avatar";
	if (user.avatar) return `<img class="${css}" src="${user.avatar}"/>`;
	return `<div class='${css} ${
		user.name ? userCss(user.name) : "webix_um_no_name"
	}'>${user.name ? user.name.charAt(0).toUpperCase() : ""}</div>`;
}
